import { UPDATE_HOVERED_LAYER } from '../actions/action-types';

const initialState = {
  layer: null
};

function current(state = initialState, action){
  switch(action.type){
    case UPDATE_HOVERED_LAYER:
      return {
        ...state,
        layer: action.layer
      };
    default:
      return state;
  }
}

export default current;

export function getLayer(state) {
  return state.layer;
}


// WEBPACK FOOTER //
// ./src/reducers/current.js